/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-range input[type='range']::-webkit-slider-thumb {
  width: var(--thumb-width);
  height: var(--thumb-height);
  background: var(--thumb-background);
  border-radius: 50%;
  box-shadow: var(--thumb-border);
  margin-block-start: calc((var(--track-height) - var(--thumb-height)) / 2);
  appearance: var(--_appearance);
  filter: var(--filter);
}

nve-range input[type='range']::-webkit-slider-runnable-track {
  background: transparent;
  height: var(--track-height);
  border-radius: var(--nve-ref-border-radius-lg);
  align-self: center;
}

nve-range:has(datalist) input[type='range']::-webkit-slider-container {
  min-block-size: auto;
}

nve-range[orientation='vertical'] input[type='range']::-webkit-slider-container {
  display: flex;
  align-items: center;
  overflow: visible;
}

nve-range[orientation='vertical'] input[type='range']::-webkit-slider-runnable-track {
  width: 100%;
  height: 100%;
}

nve-range[orientation='vertical'] input[type='range']::-webkit-slider-thumb {
  margin: 0;
}
